// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circlePartialBroken16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-partial-broken': IconCirclePartialBroken;
    }
}

/**
 * The icon component for the 'circlePartialBroken' icon
 */
export class IconCirclePartialBroken extends IconSvg {
    public constructor() {
        super(circlePartialBroken16X16);
    }
}

registerIconSvg('icon-circle-partial-broken', IconCirclePartialBroken);
export const iconCirclePartialBrokenTag = 'nimble-icon-circle-partial-broken';
